module.exports = __webpack_public_path__ + "img/CPTemp16.d96d8b62.png";